<div *ngIf="!hidePagination">
  <p-paginator
    [first]="1"
    [rows]="rowsPerPage"
    [totalRecords]="totalCount"
    [showFirstLastIcon]="false"
    styleClass="paginator"
    (onPageChange)="onPageChange($event)">
  </p-paginator>
</div>
